import React from "react";
import { Select as SelectAntd, SelectProps } from "antd";

export const Select: React.FC<SelectProps & { readOnly?: boolean }> = ({
  readOnly,
  ...props
}) => {
  return <SelectAntd {...props} open={readOnly ? false : undefined} />;
};
